/**
 * Store admin — new collection (Commerce, M6).
 * @see prototype/store/admin/all.html#collections-new
 */
import { createFileRoute } from "@tanstack/react-router";
import { CollectionNewPage } from "../../../../../features/store/collections/collection-new-page.tsx";

export const Route = createFileRoute("/(workspace)/store/admin/collections/new")({
  component: CollectionNewPage,
});
